class MainSearch extends SearchForm {
  constructor() {
    super();
    this.allSearchInputs = document.querySelectorAll('input[type="search"]');
    this.setupEventListeners();
  }

  setupEventListeners() {
    const allSearchForms = [...new Set(Array.from(this.allSearchInputs, input => input.form).filter(Boolean))];
    this.input.addEventListener('focus', this.onInputFocus.bind(this));
    if (allSearchForms.length >= 2) {
      allSearchForms.forEach(form => form.addEventListener('reset', this.onFormReset.bind(this)));
      this.allSearchInputs.forEach(input => input.addEventListener('input', this.onInput.bind(this)));
    }

    // Keep search-results-page submissions consistent with the homepage.
    // The predictive-search component already handles its own submissions.
    if (!this.closest('predictive-search') && this.input.form) {
      this.input.form.addEventListener('submit', this.onSearchSubmit.bind(this));
    }
  }

  onSearchSubmit(event) {
    const query = this.input.value.trim();
    if (!query) {
      event.preventDefault();
      return;
    }
    event.preventDefault();
    const url = new URL(window.routes?.search_url || '/search', window.location.origin);
    url.searchParams.set('q', query);
    url.searchParams.set('type', 'product');
    url.searchParams.set('options[prefix]', 'last');
    const previewThemeId = new URL(window.location.href).searchParams.get('preview_theme_id');
    if (previewThemeId) url.searchParams.set('preview_theme_id', previewThemeId);
    window.location.assign(url.toString());
  }

  onFormReset(event) {
    super.onFormReset(event);
    if (super.shouldResetForm()) this.keepInSync('', this.input);
  }

  onInput(event) {
    this.keepInSync(event.target.value, event.target);
  }

  onInputFocus() {
    if (window.innerWidth < 750) this.scrollIntoView({ behavior: 'smooth' });
  }

  keepInSync(value, target) {
    this.allSearchInputs.forEach(input => {
      if (input !== target) input.value = value;
    });
  }
}
customElements.define('main-search', MainSearch);
